import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';


const CheckEmail = ({ auth }) => {
    const location = useLocation();
    const [isOnboarding, setIsOnboarding] = useState(false);

    useEffect(() => {
        // Check if this is from onboarding by looking at the query params
        const urlParams = new URLSearchParams(location.search);
        const isFromOnboarding = urlParams.get('onboarding') === 'true';
        
        setIsOnboarding(isFromOnboarding);
    }, [location]);



    const handleTryAgain = () => {
        if (isOnboarding) {
            window.location.href = '/onboarding/leagues';
        } else {
            window.location.href = '/login';
        }
    };

    return (
        <div className="pt-5 onboarding-section">    
            <Row className="onboarding-header">
                <Col xs={1} md={2}></Col>
                <Col xs={10} md={8}>       
                        
                    <Row className="text-center onboarding-title-row">
                        <Col className="onboarding-title">Check Your Email</Col>
                    </Row>
                    
                    <Row className="pt-4">
                        <Col>
                            <div className="text-center">
                                {/* Email Icon */}
                                <div className="mb-4">
                                    <i 
                                        className="bi bi-envelope" 
                                        style={{ 
                                            fontSize: '4rem', 
                                            color: '#ffffff',
                                            marginBottom: '1rem'
                                        }}
                                    ></i>
                                </div>
                                

                                
                                {/* Instructions Card */}
                                <div className="glass-card mb-4 p-4" style={{ maxWidth: '500px', margin: '0 auto' }}>
                                    <h4 className="mb-3" style={{ color: '#ffffff', fontWeight: '600' }}>
                                        What happens next?
                                    </h4>
                                    <ol className="text-start" style={{ marginBottom: '1rem', color: '#e2e8f0', lineHeight: '1.8' }}>
                                        <li>Check your email for a message from us</li>
                                        <li>Click the magic link in the email</li>
                                        <li>You'll be automatically signed in to your account</li>
                                    </ol>
                                    
                                    {/* Try Again Link */}
                                    <p className="mb-0" style={{ color: '#94a3b8' }}>
                                        Don't see the email? Check your spam folder or{' '}
                                        <button 
                                            onClick={handleTryAgain}
                                            style={{ 
                                                textDecoration: 'none', 
                                                color: '#3b82f6',
                                                cursor: 'pointer',
                                                background: 'none',
                                                border: 'none',
                                                padding: 0,
                                                font: 'inherit',
                                                fontWeight: '500'
                                            }}
                                        >
                                            try again
                                        </button>
                                    </p>
                                </div>
                                

                            </div>
                        </Col>
                    </Row>                        
                </Col>                            
            </Row>
        </div>
    );
};

export default CheckEmail;
